export const RECLASS_ACCOUNT_ID_KEYS = ['fromTaxEntryAccountId', 'toTaxEntryAccountId'];
export const RECLASS_ACCOUNT_ID_KEYS_IN_POPUP_FORM = ['fromTaxEntryAccountId', 'taxEntryAccountId'];
export const RECLASS_ACCOUNT_ID_ERROR = 'From and To Accounts cannot be the same value.';

export const DEF = 'DEF';

export const STMAUTLNOL = 'STMAUTLNOL';
export const STMARESERV = 'STMARESERV';

export const GROSS = 'Gross';
export const NET = 'Net';

export const PROV = 'PROV';

export const UTILIZE = 'UTILIZE';

export const MULTIPLE_CURRENCIES = 'Multiple';
